// formats the children into valid options for the dropdown
export const getChildOptions = ( children ) => {
  return children.map( 
    ({ user_serial, first, last }) => {
      return { value: user_serial, label: `${user_serial}: ${first} ${last}`}
    }
  );
}


// WEBPACK FOOTER //
// ./src/pages/base-managment/parents/misc/functions.js